import React from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Tooltip, OverlayTrigger, Image, Label } from 'react-bootstrap';
import debounce from 'lodash/debounce';

import {
  LANE_NAMES,
  NOTE_CLICK_DEBOUNCE_TIME,
  TODO_ITEM_STATUSES,
} from './constants';
import MoveToLaneDropdown from './MoveToLaneDropdown';
import NoteBodyText from './NoteBodyText';

@inject('rootStore')
@observer
class NoteBody extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.handleClick = debounce(this.handleClick, NOTE_CLICK_DEBOUNCE_TIME, {
      leading: false,
      trailing: true,
    });
  }

  render() {
    const { note, intl, rootStore } = this.props;
    const { formatMessage } = intl;
    const {
      description,
      name,
      comments,
      attachments,
      creator,
      lastUser,
      labels,
      finishDate,
      priority,
      todoList,
      assignee,
    } = note;

    // todo: creator and last user must have different visual position and/or icon
    let lastActiveUser = lastUser ? lastUser : creator;
    if (note.laneStore.name === LANE_NAMES.TO_DO) lastActiveUser = creator;
    //////////////////////////////////////////////////////////////////////////////

    const lastUserShortName = lastActiveUser.name.split(' ')[0];
    const lastUserFullNameTooltip = (
      <Tooltip id="fullNameTooltip">{lastActiveUser.name}</Tooltip>
    );

    const assignedToCurrentUser =
      assignee && assignee.id === note.laneStore.rootStore.user.id;
    const assigneeShortName = assignee && assignee.name.split(' ')[0];

    const commentsMembersArray = comments
      .map(c => c.creator.name)
      .filter((value, index, array) => array.indexOf(value) === index)
      .join(', ');
    const commentsMembersTooltip = (
      <Tooltip id="commentsMembersArrayTooltip">{commentsMembersArray}</Tooltip>
    );

    const todoListCount = todoList && todoList.items && todoList.items.length;
    const doneTodoList =
      todoList &&
      todoList.items &&
      todoList.items.filter(item => item.status === TODO_ITEM_STATUSES.DONE);
    const doneTodoListCount = doneTodoList && doneTodoList.length;

    return (
      <div className="note-body-container" onClick={this.handleClick}>
        {/*{name ? <span className="badge"> {name}</span> :*/}
        {/*<div className="badge-placeholder"></div>}*/}

        <NoteBodyText note={note} />

        {!rootStore.isTaskBoard && (
          <div className="move-to-dropdown-container">
            <MoveToLaneDropdown note={note} />
          </div>
        )}

        {note.assignee && (
          <div className="note-assignee-photo-container">
            <img
              className="note-assignee-photo"
              src={note.assignee.profilePhotoUrl}
            />
          </div>
        )}

        {this.renderImage(attachments)}

        <div className="note-badges-container">
          {/*{assignedToCurrentUser && (*/}
          {/*<OverlayTrigger placement="bottom"*/}
          {/*overlay={*/}
          {/*<Tooltip id="fullNameTooltip">*/}
          {/*{formatMessage({id: 'note_assigned_to_you'})}*/}
          {/*</Tooltip>*/}
          {/*}*/}
          {/*>*/}
          {/*<span>*/}
          {/*<span className='badge assignee-badge'>A</span>*/}
          {/*&nbsp;*/}
          {/*</span>*/}
          {/*</OverlayTrigger>*/}
          {/*)}*/}
          {note.blocked && (
            <React.Fragment>
              <span
                className="fa fa-minus-circle"
                style={{ color: '#EB144C' }}
                aria-hidden="true"
              />
              &nbsp;
            </React.Fragment>
          )}
          {comments.length ? (
            <OverlayTrigger placement="bottom" overlay={commentsMembersTooltip}>
              <span>
                <span className="fa fa-comment-o" aria-hidden="true" />
                {comments.length}&nbsp;
              </span>
            </OverlayTrigger>
          ) : null}
          {attachments.length ? (
            <span>
              <span className="fa fa-paperclip" aria-hidden="true" />
              {attachments.length}&nbsp;
            </span>
          ) : null}
          <OverlayTrigger placement="bottom" overlay={lastUserFullNameTooltip}>
            <span>
              <span className="fa fa-user" />
              &nbsp;{lastUserShortName}&nbsp;
            </span>
          </OverlayTrigger>
          <span>
            <span className="fa fa-clock-o" />
            &nbsp;{intl.formatRelative(note.updatedAt)}&nbsp;
          </span>
          <span
            className="priority-square fa fa-square"
            style={{ display: 'none' }}
          />
          &nbsp;
          {note.finishDate && (
            <span className="due-date-container">
              <span className="fa fa-calendar" />
              &nbsp;{intl.formatRelative(note.finishDate)}
            </span>
          )}
          {/*{!assignedToCurrentUser && note.assignee && (*/}
          {/*<OverlayTrigger placement="bottom" overlay={*/}
          {/*<Tooltip id="">{formatMessage({id: 'note_assigned_to'})}</Tooltip>}>*/}
          {/*<span>&nbsp;<span*/}
          {/*className="fa fa-arrow-circle-right"/>&nbsp;{assigneeShortName}&nbsp;</span>*/}
          {/*</OverlayTrigger>*/}
          {/*)}*/}
          {todoList && todoList.items && todoList.items.length > 0 && (
            <span>
              <span className="fa fa-list-ul" />
              &nbsp;{doneTodoListCount}/{todoListCount}&nbsp;
            </span>
          )}
          <div className="note-badges-label-container">
            {note.activeLabels.map((label, index) =>
              this.renderLabel(label, index),
            )}
          </div>
          {!note._isPersisted() && (
            <div
              className="loader-xs"
              style={{
                display: 'inline-block',
                marginLeft: '5px',
                verticalAlign: 'middle',
              }}
            />
          )}
        </div>
      </div>
    );
  }

  renderLabel = (label, index) => {
    return (
      <Label
        className="note-badges-label"
        key={index}
        style={{ backgroundColor: label.color }}
      >
        {label.name}
      </Label>
    );
  };

  renderImage = attachments => {
    const att = attachments.find(att => {
      return (
        !att.externalLink &&
        !att.hidePreview &&
        att.attachmentName &&
        att.attachmentName.match(/.(jpg|jpeg|png|gif)$/i)
      );
    });

    if (att) {
      return (
        <div
          className="react-note-image-container"
          onClick={this.showImageInNewWindow.bind(null, att.attachmentUrl)}
        >
          <Image src={att.attachmentUrl} thumbnail />
        </div>
      );
    } else {
      return null;
    }
  };

  showImageInNewWindow(src, e) {
    // e.preventDefault();
    // e.stopPropagation();
    // window.open(src)
  }

  handleClick = e => {
    const { note, history, location } = this.props;
    const { rootStore } = note.laneStore;

    rootStore.currentNote = note;
    // rootStore.showNoteModal = true;

    // note.showNoteModal();

    // remove tailing / if exist
    let pathname = history.location.pathname;
    pathname = pathname.replace(/\/+$/, '');

    history.push(`${pathname}/note/${note.id}`, { modal: true });
  };
}

export default withRouter(injectIntl(NoteBody));
